import { render, staticRenderFns } from "./FeedDetail.vue?vue&type=template&id=10d8446e&"
import script from "./FeedDetail.vue?vue&type=script&lang=ts&"
export * from "./FeedDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports